function buildPrefixedMultiLangRoutes(
  { locales, prefix = '' },
  { guest: guestRoutes, private: privateRoutes, public: publicRoutes }
) {
  // DON'T MODIFY ORDER OF ROUTES
  const routeGroups = [
    { accessLevel: 'guest', routes: guestRoutes },
    { accessLevel: 'private', routes: privateRoutes },
    { accessLevel: 'public', routes: publicRoutes },
  ];

  const routes = routeGroups.reduce((acc, routeGroup) => {
    const appendRoute = (options) => {
      acc.push({ ...options, accessLevel: routeGroup.accessLevel });
    };
    const appendRouteWithParts = (options, parts) => {
      const pathname = parts
        .map((part) => part.replace(/^\//g, ''))
        .map((part) => part.replace(/\/$/g, ''))
        .filter(Boolean)
        .join('/');
      appendRoute({ ...options, pathname: `/${pathname}` });
    };

    routeGroup.routes
      .filter((route) => !!route)
      .forEach((route) => {
        if (route.pathname === '*') {
          appendRoute(route);
        } else {
          appendRouteWithParts(route, [prefix, route.pathname]);

          locales.forEach((locale) => {
            appendRouteWithParts(route, [prefix, locale, route.pathname]);
          });
        }
      });

    return acc;
  }, []);

  return [...new Set(routes)];
}

export default buildPrefixedMultiLangRoutes;
